<template>
  <div class="programme">
    <section class="programme__hero">
      <div class="programme__hero-overlay" />
      <div class="programme__hero-content">
        <h1>Programme</h1>
      </div>
    </section>

    <section class="programme__content">
      <div class="programme__inner">
        <div class="programme__day">
          <h2 class="programme__day-title">
            Samedi 13 juin 2026
          </h2>
          <div class="programme__timeline">
            <div
              v-for="event in samedi"
              :key="event.time"
              class="programme__event"
            >
              <span class="programme__time">{{ event.time }}</span>
              <div class="programme__dot" />
              <div class="programme__detail">
                <h3>{{ event.title }}</h3>
                <p v-if="event.desc">
                  {{ event.desc }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="programme__divider" />

        <div class="programme__day">
          <h2 class="programme__day-title">
            Dimanche 14 juin 2026
          </h2>
          <div class="programme__timeline">
            <div
              v-for="event in dimanche"
              :key="event.time"
              class="programme__event"
            >
              <span class="programme__time">{{ event.time }}</span>
              <div class="programme__dot" />
              <div class="programme__detail">
                <h3>{{ event.title }}</h3>
                <p v-if="event.desc">
                  {{ event.desc }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="programme__divider" />

        <div class="footer__photo">
          <img
            src="../images/20220820_194915.jpg"
            alt="Elena & Antoine"
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
const samedi = [
  { time: "17h30", title: "Rendez-vous au château", desc: "Cérémonie laïque" },
  { time: "19h00", title: "Vin d'honneur", desc: "Cocktail en extérieur" },
  { time: "21h00", title: "Dîner", desc: "Assis et placé" },
  { time: "23h00", title: "Ouverture de bal", desc: "Soirée dansante" },
]

const dimanche = [
  { time: "11h00", title: "Brunch", desc: "Pour se remettre doucement de nos émotions" },
]
</script>

<style lang="scss" scoped>
@import "../base/mixins";

.programme__hero {
  position: relative;
  height: 50vh;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-image: url('../images/Amour-Etc.168.jpeg');
  background-size: 102%;
  background-position: 0% 15%;

  @media (max-width: $bp-mobile) {
    max-height: 300px;
    min-height: 300px;
    background-size: 160%;
    background-position: 40% 20%;
  }
}

.programme__hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba($color-text-primary, 0.3);
}

.programme__hero-content {
  position: relative;
  z-index: 1;

  h1 {
    color: $color-white;
    font-weight: 300;
    letter-spacing: 0.05em;
  }
}

.programme__content {
  @include section-padding;
}

.programme__inner {
  @include container;
  max-width: $container-wide;
}

.programme__day-title {
  text-align: center;
  margin-bottom: $spacing-block;
  font-weight: 300;
}

.programme__timeline {
  display: flex;
  flex-direction: column;
}

.programme__event {
  display: grid;
  grid-template-columns: 70px 20px 1fr;
  gap: $spacing-element;
  align-items: start;
  padding-bottom: $spacing-block;
  position: relative;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child) .programme__dot::after {
    content: '';
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    height: calc(100% + 28px);
    background-color: $color-border;
  }
}

.programme__time {
  @include body-text;
  font-size: 0.85rem;
  letter-spacing: 0.05em;
  color: $color-accent;
  text-align: right;
  padding-top: 2px;
}

.programme__dot {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1.5px solid $color-accent;
  background-color: $color-bg-primary;
  margin-top: 4px;
  justify-self: center;
}

.programme__detail {
  h3 {
    font-size: 1.1rem;
    margin-bottom: $spacing-element-sm;
  }

  p {
    @include body-text;
    font-size: 0.9rem;
    color: $color-text-secondary;
  }
}

.programme__divider {
  width: 60px;
  height: 1px;
  background-color: $color-accent;
  margin: $spacing-block-lg auto;
}

.footer__photo {
  margin-bottom: $spacing-block;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    max-height: 500px;
    max-width: $container-wide;
    object-fit: cover;
  }
}
</style>
